import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  OuterLogIn,
  LogInHeader,
  SubHeader,
} from './styles';
import HudsonLogo from '../../components/hudsonlogos-01.png';
import PasswordInput from '../../components/PasswordInput';
import LinkButton from '../../components/LinkButton';
import MediaButtons from '../../components/MediaButtons';
import { useParams } from 'react-router-dom';
import AuthenticationLayout from './AuthenticationLayout';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';

interface Props {
  isError?: boolean;
  labelText?: string;
  passwordRequirements?: boolean;
  header?: string;
  buttonText?: string;
  subHeader?: boolean;
  linkButton?: boolean;
  reset?: boolean;
}
const CreateResetPassword = (props: Props) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [validToken, setValidToken] = useState(true);
  const { token } = useParams<{ token: string }>();
  const history = useHistory();
  const { setUserContext } = useUserContext();
  let regex = /[^a-zA-Z0-9]/g;
  useEffect(() => {
    const checkToken = async () => {
      const { data } = await axios.get(
        `/api/clientaccount/GetIsTokenValid?token=${token}`
      );
      setValidToken(data);
    };
    if (token) {
      checkToken();
    }
  }, [token]);

  function handleClick(e: any) {
    if (e.key === 'Enter') 
    {
      props.reset ? onResetSubmit() : onCreateSubmit()
    }
   }
  const onCreateSubmit = async () => {
    if (confirmPasswordError || password === '' || confirmPassword === '' || !regex.test(password) || password.length < 8) {
      return;
    }
    const { data } = await axios.post(`/api/clientaccount/activate`, {
      token,
      password,
    });
    setUserContext(data);
    history.push('/home')
  };
  const onResetSubmit = async () => {
    if (confirmPasswordError || password === '' || confirmPassword === '' || !regex.test(password) || password.length < 8) {
      return;
    }
    const { data } = await axios.post(`/api/clientaccount/ResetPassword`, {
      token,
      password,
    });
    setUserContext(data);
    history.push('/login')
  };
  const handleOnBlur = () => {
    if (confirmPassword !== password) {
      setConfirmPasswordError(true);
    } else {
      setConfirmPasswordError(false);
    }
  };
  return (
    <>
      <AuthenticationLayout>
        <OuterLogIn onKeyDown={handleClick}>
          {!validToken ? (
            props.reset ? (
              <div style={{ padding: 80 }}>
                <LogInHeader>Invalid Link</LogInHeader>
                <div
                  style={{
                    marginTop: 36,
                    maxWidth: 420,
                    lineHeight: 1.7,
                    marginBottom: 16,
                  }}
                >
                  The link that you have used is invalid. This could be because
                  of a typo, expiration, or security issue. Request a new link
                  to reset your password.
                </div>
                <LinkButton
                  linkText='Back to Reset Password'
                  href='/forgot-password'
                />
              </div>
            ) : (
              <div style={{ padding: 80 }}>
                <LogInHeader>Invalid Link</LogInHeader>
                <div style={{ marginTop: 36, maxWidth: 450, lineHeight: 1.7 }}>
                  The link that you have used is invalid. This could be because
                  of a typo, expiration, or security issue. Contact
                  orders@hudsonsearch.com for a new link.
                </div>
              </div>
            )
          ) : (
            <div
              style={{
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div style={{ textAlign: 'left' }}>
                <img src={HudsonLogo} style={{ width: 105, height: 42 }} alt=''/>
                <LogInHeader>{props.header}</LogInHeader>
                {props.subHeader && (
                  <SubHeader>
                    Please set up your password to finish creating your account.
                    You will use this password to access the portal.
                  </SubHeader>
                )}
                <PasswordInput
                  passwordConditions
                  labelText='Password'
                  onChange={(value) => setPassword(value)}
                  value={password}
                />
                <PasswordInput
                  labelText='Confirm Password'
                  isError={confirmPasswordError}
                  onChange={(value) => setConfirmPassword(value)}
                  value={confirmPassword}
                  onBlur={handleOnBlur}
                  isColor={confirmPasswordError}
                />
                <MediaButtons
                  widthMobile='343px'
                  widthDesktop='444px'
                  onClick={() =>
                    props.reset ? onResetSubmit() : onCreateSubmit()
                  }
                  buttonType={
                    confirmPasswordError
                      ? 'ButtonPrimaryTwoLargeDisabled'
                      : 'ButtonPrimaryTwoLarge'
                  }
                  buttonText={props.buttonText}
                />
                {props.linkButton && (
                  <LinkButton linkText='Go to Log In' href='login' />
                )}
              </div>
            </div>
          )}
        </OuterLogIn>
      </AuthenticationLayout>
    </>
  );
};

export default CreateResetPassword;
